// Country options for the self-signup form's countryAlpha field.
//
// The signup endpoint takes an ISO alpha country code and maps it to a
// numeric code server-side. The wireframes are US-focused, so US is the
// default; Canada is included because US_STATE_OPTIONS in labels.ts
// already carries Canadian provinces for cross-border merchants. Keep
// this list here (not inline in the page) so it stays reusable.

import type { LabeledOption } from "./labels";

export const COUNTRY_OPTIONS: readonly LabeledOption[] = [
  { value: "US", label: "United States" },
  { value: "CA", label: "Canada" },
];

export const DEFAULT_COUNTRY_ALPHA = "US";
